import React, { useMemo } from 'react';
import { PropTypes } from 'prop-types';
import Table from '../table/Table';

const DEFAULT_DEFAULT_SORT_ORDER = {
  sortBy: '',
  order: '',
};

const NotesTable = ({
  notes, onSort, onClick, defaultSortOrder = DEFAULT_DEFAULT_SORT_ORDER,
}) => {
  const columns = useMemo(() => [
    {
      title: 'Site',
      dataIndex: 'site_name',
      className: 'w-56 max-w-24 md:max-w-56 truncate',
      isSortable: true,
    },
    {
      title: 'Title',
      dataIndex: 'title',
      className: 'w-72 max-w-34 md:max-w-72 truncate',
      isSortable: true,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      className: 'w-40',
      isSortable: true,
    },
    {
      title: 'Priority',
      dataIndex: 'priority',
      className: 'w-44',
      isSortable: true,
    },
    {
      title: 'Date',
      dataIndex: 'timestamp',
      className: 'w-36',
      isSortable: true,
    },
  ], []);
  return (
    <div className="flex justify-center w-full">
      <Table
        dataSource={notes}
        columns={columns}
        onSort={(values) => {
          onSort(values.field, values.order);
        }}
        typeOfData="notes"
        onClick={onClick}
        defaultSortOrder={defaultSortOrder}
      />
    </div>
  );
};

NotesTable.propTypes = {
  onSort: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  notes: PropTypes.array.isRequired,
  defaultSortOrder: PropTypes.shape({
    sortBy: PropTypes.string,
    order: PropTypes.string,
  }),

};

export default React.memo(NotesTable);
